import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findProcedures = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/procedures${query}`,
    {
      headers,
    },
  );
};

export const findProcedureById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/procedures/${id}`,
    {
      headers,
    },
  );
};

export const createProcedure = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_CATEGORY_API_URL}/procedures`,
    data,
    {
      headers,
    },
  );
};

export const updateProcedure = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/procedures/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteProcedure = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/procedures/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteProcedures = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/procedures?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
